FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};


    /* ========================================================================
     *  private vars
     * ========================================================================
    */

    var ELEM = '[data-fd="text"]';
    var DELAY = 800; // Milliseconds
    var eventsAreSet = false;
    var hitEnter = false;

    //  defaults
    var defaults = {
        useparent: true,
        parentid: -1,
        callbackprefix: 1,
        tag: 60,
        value: '',

        initial: '',
        max: 200,                   //  max length
        min: 0,                     //  min length
        length: 0,                  //  length
        repeat: false,              //  repeat input
        focus: false,
        iskeyup: false,
        noedit: false,
        clearonload: false,
        submitevent: 'blur' //Other options include: enter, tab, blur
    };


    var keyCode = {
        ENTER: 13,
        BACKSPACE: 8,
        ESC: 27,
        TAB: 9
    };

    /* ========================================================================
     *  private methods
     * ========================================================================
    */


    //  set events
    function setEvents() {
        var NAMESPACE = me.getUID('CTRL_');

        //  set events
        $(document).off('focus blur keyup keydown', ELEM)
            .on('focus.' + NAMESPACE, ELEM, setFocus)
            .on('blur.' + NAMESPACE, ELEM, setBlur)
            .on('paste.' + NAMESPACE, ELEM, function (e) {
                var e = $(this);
                var data = e.data();

                //  check for keyup
                if (data.iskeyup) {
                    if (this.controlDelay) {
                        clearTimeout(this.controlDelay);
                        this.controlDelay = undefined;
                    }

                    this.controlDelay = setTimeout(function () {
                        setKeyUp(e);
                    }, DELAY);
                }
            })
            .on('keyup.' + NAMESPACE, ELEM, function (event) {
                var e = $(this);
                var data = e.data();
                //  esc
                if (Number(event.which) === keyCode.ESC || Number(event.keyCode) === keyCode.ESC) {
                    e.val(data.initial);
                    me.setInputFocus(e, false);
                    return;
                }

                //  check for keyup
                if (data.iskeyup) {
                    if (this.controlDelay) {
                        clearTimeout(this.controlDelay);
                        this.controlDelay = undefined;
                    }

                    this.controlDelay = setTimeout(function () {
                        setKeyUp(e);
                    }, DELAY);
                }
            })
            .on('keydown.' + NAMESPACE, ELEM, function (event) {
                //  backspace
                if (Number(event.which) === keyCode.BACKSPACE || Number(event.keyCode) === keyCode.BACKSPACE || Number(event.which) === keyCode.TAB || Number(event.keyCode) === keyCode.TAB) {
                    return true;
                }

                if ($(this).val().length > Number($(this).data('max'))) {
                    return false;
                }
            })
            .on('keypress.' + NAMESPACE, ELEM, function (event) {
                var e = $(this);
                var data = e.data();

                if (Number(event.which) === keyCode.ENTER || Number(event.keyCode) === keyCode.ENTER) {
                    hitEnter = true;
                    e.blur();

                    //  repeat 
                    if (data.repeat && data.submitevent.indexOf('enter') > -1) {
                        e.focus();
                    }
                    return;
                }
            });
    }


    //  get text 
    function getText(wireEvent, container) {
        var list = [];

        if (container !== null) {
            if (typeof container === 'string') {
                container = $(container);
            }
            list = container.find(ELEM);
        } else {
            list = $(ELEM);
        }

        if (wireEvent && !eventsAreSet) {
            setEvents();
            eventsAreSet = true;
        }

        if (list.length === 0) {
            return;
        }

        list.each(function (i, e) {
            var elem = $(e);

            var options = $.extend({}, defaults, elem.data());
            me.setControlItemOptions(elem, options);
            elem.data(options);

            if (options.clearonload) {
                elem.val('');
                options.clearonload = false;
                elem.data('clearonload', false).attr('data-clearonload', false);
            }

            if (options.noedit) {
                elem.attr('readonly', true);
            }
        });
    }


    function setFocus() {
        var e = $(this);

        if (document.isUndo) {
            document.isUndo = false;
            return;
        }
        e.data('initial', e.val());
        hitEnter = false;

        if (e.data('focus') === true) {
            e.select();
        }
    }


    function setKeyUp(e) {
        if (e.val() === e.data('initial')) {
            return;
        }

        e.data('element', e);
        var val = e.val();
        if (val.length < +e.data('min')) {
            val = e.data('initial');
            e.val(val);
        }

        e.data('value', val).data('length', val.length);

        setCallback(e);
    }


    function setBlur() {
        var e = $(this);
        
        if ((e.data('submitevent') && e.data('submitevent').indexOf('enter') > -1 && !hitEnter && e.data('submitevent').indexOf('blur') == -1) || (e.data('submitevent') && e.data('submitevent').indexOf('tab') > -1 && hitEnter)) {
            e.data('initial', e.val());
            return;
        }

        if (e.data('iskeyup')) {
            return;
        } else if (e.val() === e.data('initial') && !hitEnter) {
            return;
        }

        e.data('element', e);
        var val = e.val();

        if (val.length < e.data('min')) {
            val = e.data('initial');
            e.val(val);
        }

        e.data('value', val).data('length', val.length);

        if (e.data('repeat')) {
            e.val('');
        }
        setCallback(e);
    }


    function setCallback(e) {
        var data = e.data();

        me.setCallBackFromData(e, { e: data.element, value: data.value, initial: data.initial, tag: data.tag, parentid: data.parentid, length: data.length || 0 });
        e.data('initial', data.value);
    }


    /* ========================================================================
     *  public methods
     * ========================================================================
    */


    child.setText = function (wireEvent, container) {
        getText(wireEvent, container);
    };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));